module.exports = __webpack_public_path__ + "img/active-layer5.1efa37d7.png";